const TYPENAMES = {
  articleHeader: 'ArticleHeader',
  articleHeaderImage: 'ArticleHeaderImage',
  articleAuthor: 'ArticleAuthor',
  articleOverview: 'ArticleOverview',
  PublicationViewed: 'PublicationViewed',
  assetCollection: 'AssetCollection',
  audioEmbed: 'AudioEmbed',
  brandHeader: 'BrandHeader',
  brandNavigation: 'Brandnavigation',
  brandTitleBar: 'BrandTitleBar',
  button: 'Button',
  cardList: 'CardList',
  cardOverview: 'CardOverview',
  catalogNavigation: 'CatalogNavigation',
  catalogOverview: 'CatalogOverview',
  comments: 'Comments',
  donationForm: 'DonationForm',
  download: 'Download',
  facebookEmbed: 'FacebookEmbed',
  footer: 'Footer',
  form: 'Form',
  heading: 'Heading',
  imageAndText: 'ImageAndText',
  instagramEmbed: 'InstagramEmbed',
  likeButton: 'LikeButton',
  mediaHeader: 'MediaHeader',
  mediaOverview: 'MediaOverview',
  membershipForm: 'MembershipForm',
  mixedContentSlider: 'MixedContentSlider',
  newsletterSubscription: 'NewsletterSubscription',
  onboardingBanner: 'OnboardingBanner',
  onboardingInformationLink: 'OnboardingInformationLink',
  personNavigation: 'PersonNavigation',
  personOverview: 'PersonOverview',
  photo: 'Photo',
  playerEmbed: 'PlayerEmbed',
  popularByBrandRecommendationList: 'PopularByBrandRecommendationList',
  popularRecommendationList: 'PopularRecommendationList',
  profile: 'Profile',
  profileHeader: 'ProfileHeader',
  propositionList: 'PropositionList',
  qualifioEmbed: 'QualifioEmbed',
  quote: 'Quote',
  recommendationList: 'RecommendationList',
  scrollIntoView: 'ScrollIntoView',
  socialFooter: 'SocialFooter',
  spacer: 'Spacer',
  noMemberPlaceholder: 'NoMemberPlaceholder',
  spotifyEmbed: 'SpotifyEmbed',
  standalonePageHeader: 'StandalonePageHeader',
  sterBanner: 'SterBanner',
  subNavigation: 'SubNavigation',
  tagList: 'TagList',
  tagOrCategoryItems: 'TagOrCategoryItems',
  teaser: 'BrandTeaser',
  text: 'Text',
  theaterPlayerEmbed: 'TheaterPlayerEmbed',
  topBar: 'TopBar',
  tweetEmbed: 'TweetEmbed',
  unsubscribeEmailNotification: 'UnsubscribeEmailNotification',
  urlReference: 'UrlReference',
  youtubeEmbed: 'YoutubeEmbed',
  vimeoEmbed: 'VimeoEmbed',
  vimeoChatEmbed: 'VimeoChatEmbed',
  vimeoVideoWithChatEmbed: 'VimeoVideoWithChatEmbed',
  welcomeDashboard: 'WelcomeDashboard',
};

export default TYPENAMES;
